export default __webpack_public_path__ + "static/media/DistressedSM.31d96ab5.jpg";